import { AnalysisMode } from '@customer/store/apis/investigationsApi';

// Static field limits
export const MAX_INVESTIGATION_NAME = 50;
export const MIN_INVESTIGATION_ASSETS = 1;
export const MIN_INVESTIGATION_DURATION = 1;
export const MAX_INVESTIGATION_PREVIOUS_DAYS = 92; // days, the maximum possible value of 3 consecutive months.

// Dynamic field limits
const MAX_INVESTIGATION_ASSETS_BASIC = 5;
const MAX_INVESTIGATION_ASSETS_ENHANCED = 3;
const MAX_INVESTIGATION_DURATION_BASIC = 240; // 4 hours
const MAX_INVESTIGATION_DURATION_ENHANCED = 10; // minutes
const START_TIME_INTERVAL_BASIC = 15; // minutes
const START_TIME_INTERVAL_ENHANCED = 5; // minutes

interface AnalysisModeLimitItem {
  startTimeInterval: number;
  maxDuration: number;
  maxAssets: number;
}

export const AnalysisModeLimits: Record<AnalysisMode, AnalysisModeLimitItem> = {
  [AnalysisMode.Basic]: {
    startTimeInterval: START_TIME_INTERVAL_BASIC,
    maxDuration: MAX_INVESTIGATION_DURATION_BASIC,
    maxAssets: MAX_INVESTIGATION_ASSETS_BASIC,
  },
  [AnalysisMode.Enhanced]: {
    startTimeInterval: START_TIME_INTERVAL_ENHANCED,
    maxDuration: MAX_INVESTIGATION_DURATION_ENHANCED,
    maxAssets: MAX_INVESTIGATION_ASSETS_ENHANCED,
  },
};
